import { useLocale } from "@/i18n/useLocale";

const AppleLogo = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="currentColor">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const _isSafeReturnTo = (r) =>
  typeof r === "string" &&
  (r.startsWith("/partner/") || r.startsWith("/partners/")) &&
  !r.includes("//") &&
  !r.includes("\\");

export const AppleButton = ({ label, intent, returnTo, testId = "apple-signin" }) => {
  const { t } = useLocale();
  const go = () => {
    const base = `${process.env.REACT_APP_BACKEND_URL}/api/auth/apple/start`;
    const params = new URLSearchParams();
    if (intent) params.set("intent", intent);
    if (returnTo && _isSafeReturnTo(returnTo)) params.set("return_to", returnTo);
    const qs = params.toString();
    window.location.href = qs ? `${base}?${qs}` : base;
  };
  return (
    <button type="button" onClick={go} data-testid={testId}
      className="flex w-full items-center justify-center gap-2.5 rounded-full border border-white/15 bg-black px-5 py-2.5 text-sm font-medium text-white transition-all hover:bg-white/10 active:scale-[0.98]">
      <AppleLogo /> {label || t("auth.continueApple")}
    </button>
  );
};
